import React from 'react';
import ReactDOM from 'react-dom/client';
import './Globle.css';
import App from './container/App';
import reportWebVitals from './reportWebVitals';
import { CarrommProvider } from './context/carrom';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CarrommProvider>
      <App />
      <Toaster position="bottom-center" toastOptions={{
        style: {
          backgroundColor: "#c40013",
          color: 'white' ,
        },
      }} />
    </CarrommProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
